import { atom } from 'recoil';
import { sessionStorageEffect } from '../effects/sessionStorageEffect';
import { SpeedTestStatus } from 'types/NetworkScan/SpeedTestStatus';

export interface RouterState {
  scanState: SpeedTestStatus;
}

export const routerState = atom<RouterState>({
  key: 'routerState',
  default: {
    scanState: SpeedTestStatus.none,
  },
  effects: [sessionStorageEffect('routerState', ['scanState'])],
});
